import { ModTaskTreeView } from "open-modules/zdf/component/moddashboard/modtasktree";
import { Feature } from "util/stdtypes";

export const EnableModTaskTreeViewFeature : Feature<any, {}> = {
    name: "Enable Mod Task Tree View",
    key: "enablemodtasktreeview",
    dev: true,
    subscreens: {
        modTaskTreeView: () => <ModTaskTreeView />,
    }
};